import { Checkbox, CheckboxType } from '@components/Checkbox';

interface Props {
    disabled?: boolean;
    className?: string;
    isChecked: boolean;
    onChange(event: React.ChangeEvent<HTMLInputElement>, checked?: boolean): void;
}

export function TableCheckbox({ className, isChecked, onChange, disabled }: Props) {
    return (
        <div className={className}>
            <Checkbox
                disabled={disabled}
                isChecked={isChecked}
                dataTest={''}
                type={CheckboxType.Small}
                onChange={onChange}
            />
        </div>
    );
}
